module.exports = __webpack_public_path__ + "static/07-ed6d61da17991193b414db4ed277a08c.jpg";